import { useMediaQuery } from '@bingads-webui-campaign-react/common-hooks';

import { useIsHookedInWizard } from '../integration-context';

export const useMobileSupportEnabled = () => {
  const { isMobile } = useMediaQuery();
  const isHookedInWizard = useIsHookedInWizard();

  return isMobile && isHookedInWizard;
};
